import { useSyncExternalStore } from 'react'

const subscribeFullscreen = (onStoreChange: () => void) => {
    document.addEventListener('fullscreenchange', onStoreChange)
    return () => document.removeEventListener('fullscreenchange', onStoreChange)
}

const getFullscreenContainer = () => document.fullscreenElement as HTMLElement | null

export const useFullscreenContainer = () =>
    useSyncExternalStore(subscribeFullscreen, getFullscreenContainer, () => null)
